import type { Instance, TaskChain } from "@/types/dataflow";

export interface TaskChainGroup {
  batch: TaskChain;
  instances: Instance[];
}

export function buildTaskChainGroups(
  taskChains: TaskChain[],
  instances: Instance[]
): TaskChainGroup[] {
  const instancesByBatch = new Map<number, Instance[]>();

  for (const instance of instances) {
    if (instance.batch_id == null) {
      continue;
    }
    const existing = instancesByBatch.get(instance.batch_id) ?? [];
    existing.push(instance);
    instancesByBatch.set(instance.batch_id, existing);
  }

  return taskChains.map((batch) => ({
    batch,
    instances: (instancesByBatch.get(batch.id) ?? []).slice().sort((left, right) => left.id - right.id),
  }));
}

export function buildBatchGroups(taskChains: TaskChain[], instances: Instance[]): TaskChainGroup[] {
  return buildTaskChainGroups(taskChains, instances);
}
